import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApiService} from "@biletix/core/services/api.service";
import {Observable} from "rxjs";
import {ApiResponse} from "@biletix/core/models/api-response";
import {map} from "rxjs/operators";
import {IGKResult} from "@biletix/core/models/tff/IGKResult";
import {Router} from "@angular/router";
import {RouterService} from "@biletix/core/services/router.service";

@Injectable()
export class TffMatchService {

  private tffBasePath: string = "/api/v1/mys/match";

  constructor(private http: HttpClient,
              private router:Router,
              private routerService:RouterService,
              private apiService: ApiService) {
  }

  getIGKResult(eventId:string): Observable<ApiResponse<IGKResult>> {
    return this.http
      .get<ApiResponse<IGKResult>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/checkCustomer/${eventId}`)
      .pipe(map(response => response));
  }

}
